import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ApiValidation} from "../../model/api/api-validation";
import {Observable} from "rxjs";
import {Order} from "../../model/clearing/order";
import {CrystalclearDataAmendmentBackUrl} from "../config/crystalclear-data-amendment-back-url";
import {OrderAmendmentChangeRequest} from "../../model/data-amendment/order-amendment-change-request";
import {OrderAmendmentListRequest} from "../../model/data-amendment/order-amendment-list-request";

@Injectable({
  providedIn: 'root'
})
export class OrderAmendmentService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public list(request: OrderAmendmentListRequest): Observable<TableRecordResult<Order>> {
    return this.post(CrystalclearDataAmendmentBackUrl.GET_ORDER_LIST, request);
  }
  public saveOrders(request: OrderAmendmentChangeRequest): Observable<ApiValidation<any>> {
    return this.post(CrystalclearDataAmendmentBackUrl.POST_ORDER_SAVE, request);
  }
}
